<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('course_assessment')" :isNewButton="checkPermission('course_index')"
                        :isColumns="true"
                        @new-button-click="createFormShow()"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                             :unchecked-value="true" v-model="column.hidden"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('course_assessment')"
                              @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                             :unchecked-value="true" v-model="column.hidden"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                        <b-col sm="6" md="4" lg="4" xl="3" >
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col sm="6" md="4" lg="4" xl="3">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="datatable.queryParams.filter.surname" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="4" xl="3">
                            <b-form-group :label="$t('student_number')">
                                <b-form-input size="sm" v-model="datatable.queryParams.filter.student_name" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="4" xl="3">
                            <b-form-group :label="$t('academic_year')">
                                <academic-years-selectbox v-model="datatable.queryParams.filter.academic_year"></academic-years-selectbox>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="4" xl="3">

                        <b-form-group :label="$t('faculty')">
                                <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code"
                                                />
                            </b-form-group>
                        </b-col>
                    <b-col sm="6" md="4" lg="4" xl="3">
                    <b-form-group :label="$t('program')">
                            <program-selectbox v-model="datatable.queryParams.filter.program_code"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="4" xl="3">
                        <b-form-group :label="$t('status')">

                        <parameter-selectbox v-model="datatable.queryParams.filter.status"
                                             code="course_agreement_statuses"
                        />
                        </b-form-group>
                    </b-col>


                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
                       @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"


import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import qs from 'qs'
import CourseAgreementFormHeadOfDepartmentServices from "@/services/StudentCourseAgreementServices";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,

    },
    metaInfo() {
        return {
            title: this.$t('course_program_outcomes')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "courseagreement_show",
                                callback: (row) => {
                                    this.$router.push('/student/course/agreement/'+row.id);
                                }
                            },
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false,
                    },

                    {
                        label: this.toUpperCase('academic_year'),
                        field: 'academic_year',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('faculty_name'),
                        field: this.getLocaleField('faculty_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('program_name'),
                        field: this.getLocaleField('program_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('registration_type'),
                        field: this.getLocaleField('registration_type'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('status'),
                        field: this.getLocaleField('status_name'),
                        hidden: false,
                    },


                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: '-id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {},
        }
    },
    created() {
        this.filterSet();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {}
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            return CourseAgreementFormHeadOfDepartmentServices.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },

    }
}
</script>

